<template>
	<section>
		<h2 class="onboarding-title">You're all set!</h2>
		<p class="onboarding-text lead">
			Have a wonderful journey with Grub Vision, and we've got your back on
			every plate.
		</p>
		<div class="celebrate">
			<i class="bi bi-stars"></i>
			<div class="spark"></div>
			<div class="spark delay"></div>
			<div class="spark slow"></div>
		</div>
		<p class="onboarding-note">
			Be sure to visit your profile any time for even more options you can set.
		</p>
	</section>
</template>

<script setup></script>

<style scoped>
	.celebrate {
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
		margin: 1.5rem auto 1rem;
		width: 140px;
		height: 140px;
		border-radius: 50%;
		background: linear-gradient(
			135deg,
			rgba(96, 165, 250, 0.3),
			rgba(45, 212, 191, 0.3)
		);
		overflow: hidden;
	}

	.celebrate i {
		font-size: 3rem;
		color: #2563eb;
		z-index: 1;
	}

	.spark {
		position: absolute;
		width: 6px;
		height: 6px;
		border-radius: 50%;
		background: #f97316;
		animation: sparkMove 2.5s ease-in-out infinite;
	}

	.spark.delay {
		animation-delay: 0.4s;
		background: #eab308;
	}

	.spark.slow {
		animation-delay: 1s;
		animation-duration: 3.2s;
		background: #22c55e;
	}

	.onboarding-note {
		margin-top: 1rem;
		color: #334155;
		font-weight: 600;
	}

	@keyframes sparkMove {
		0%,
		100% {
			transform: translate3d(0, 0, 0);
			opacity: 0;
		}
		15%,
		70% {
			opacity: 1;
		}
		50% {
			transform: translate3d(40px, -40px, 0);
		}
	}

	@media (prefers-reduced-motion: reduce) {
		.spark {
			animation: none !important;
		}
	}
</style>
